import {Component, inject, OnDestroy, ChangeDetectionStrategy} from '@angular/core';
import {FormsModule, NgForm} from '@angular/forms';
import {Router, RouterLink} from '@angular/router';
import {Subscription} from 'rxjs';
import {AuthService} from '../../../services/auth-service';

@Component({
  selector: 'app-forgot-password-component',
  imports: [
    FormsModule,
    RouterLink
  ],
  templateUrl: './forgot-password-component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './forgot-password-component.scss'
})
export class ForgotPasswordComponent implements OnDestroy {

  private subscription: Subscription | null = null;
  private timeoutId: ReturnType<typeof setTimeout> | null = null;

  error: string | undefined;
  successMessage: string | undefined;
  loading = false;

  email = '';

  private authService: AuthService = inject(AuthService);
  private router: Router = inject(Router);

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    if (this.timeoutId !== null) {
      clearTimeout(this.timeoutId);
    }
  }

  submit(form: NgForm) {
    this.error = undefined;
    if (form.valid && !this.loading) {
      this.loading = true;
      this.subscription = this.authService.requestPasswordReset(this.email)
        .subscribe(result => {
          if (result.data) {
            this.successMessage = 'Письмо с инструкциями по восстановлению пароля отправлено на ваш email. Вы будете перенаправлены на страницу входа.';
            this.timeoutId = setTimeout(() => {
              this.router.navigate(['/login']);
            }, 3000);
          } else {
            this.error = result.error;
            this.loading = false;
          }
        });
    }
  }
}
